import { Config } from './config';

export class AppConfiguration{
    appName: string;
    environment: string | undefined;
    domainConfig:Config | undefined; 
    sideMenu: undefined;
}